import React from 'react';
import { SearchIcon, DatabaseIcon } from 'lucide-react';
interface DataDirectoryHeroProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
export function DataDirectoryHero({
  searchQuery,
  setSearchQuery
}: DataDirectoryHeroProps) {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8" data-id="element-731">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 text-center relative overflow-hidden" data-id="element-732">
        <div className="relative z-10 max-w-4xl mx-auto" data-id="element-733">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-full text-sm font-semibold mb-8 border border-blue-100" data-id="element-734">
            <DatabaseIcon className="w-4 h-4" data-id="element-735" />
            Data Directory
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 mb-6" data-id="element-736">
            All local business <span className="text-blue-600" data-id="element-737">categories</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-500 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-738">
            Browse our complete local business database of 300+ business types.
            Find the perfect local business listings for your needs.
          </p>

          <div className="relative max-w-2xl mx-auto" data-id="element-739">
            <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none" data-id="element-740">
              <SearchIcon className="h-5 w-5 text-slate-400" data-id="element-741" />
            </div>
            <input type="text" className="block w-full pl-12 pr-4 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-base placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all" placeholder="Search categories (e.g. Plumbers, Dentists)..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-742" />
          </div>
        </div>
      </div>
    </section>;
}